import React, { useEffect, useCallback, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import * as _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import SearchBox from 'components/general/SearchBox';
import moment from 'moment';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { BsDownload } from 'react-icons/bs';
import DateTimePicker from 'components/inputs/DateTimePicker';
import fileDownload from 'js-file-download';
import { Formik, Form } from 'formik';
import Select from 'components/inputs/Select';
import { MdClear } from 'react-icons/md';
import OffCanvas from 'components/inputs/OffCanvas';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import { useTranslation } from 'react-i18next';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { FaFilter } from 'react-icons/fa';
import Footer from 'components/general/Footer';
import { DOWNLOAD_EMSP_FAULTY_SESSIONS, EMSP_FAULTY_SESSIONS } from 'actions/partnerManagement';
import ReactPagination from 'components/general/ReactPagination';
import { toast } from 'react-toastify';

const EMSPFaultySessionReport = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [searchText, setSearchText] = useState('');
    const [showAdvanceFilterPopup, setShowAdvanceFilterPopup] = useState(false);
    const [advanceFilterData, setAdvanceFilterData] = useState({});
    const [startDate, setStartDate] = useState(moment(new Date()).startOf('day'));
    const [endDate, setEndDate] = useState(moment(new Date()).endOf('day'));
    const emspFaultySessionReportList = useSelector((state) => state.partnerManagement.emspFaultySessionReportList);
    const allPartyIdList = useSelector((state) => state.partnerManagement.partyIds);
    const allFaultyBookingReasonList = useSelector((state) => state.partnerManagement.faultybookings);
    const isLoader = useSelector((state) => state.partnerManagement.isLoading);
    const page = useSelector((state) => state.partnerManagement.page);
    const limit = useSelector((state) => state.partnerManagement.limit);
    const totalPages = useSelector((state) => state.partnerManagement.totalPages);
    const totalResults = useSelector((state) => state.partnerManagement.total);
    const isLoading = useSelector((state) => state.downloadingLoader.isLoading);
    const profileData = useSelector((state) => state.profile.userProfile);
    const currentUserName = _.get(profileData, 'name', '');

    const emspFaultySessionReport = useCallback(
        (value = {}) => {
            const payload = {
                ...value,
                page: value.page || 1,
                limit: value.limit || 10, // you can replace 10 with a variable defaultLimit if needed
                from: moment(startDate).utc(),
                to: moment(endDate).utc(),
            };

            if (searchText) {
                payload.search = searchText;
            }

            dispatch({
                type: EMSP_FAULTY_SESSIONS.REQUEST,
                payload,
                cb: (res) => {
                    if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
                        onCloseAdvanceFilterPopup();
                    }
                },
            });
        },
        [startDate, endDate, searchText]
    );


    const dateFilter = useCallback(() => {
        if (!_.isEmpty(advanceFilterData)) {
            const data = {
                ...advanceFilterData,
                page: page.selected + 1,
                from: moment(startDate).utc(),
                to: moment(endDate).utc(),
            };
            emspFaultySessionReport(data);
        } else {
            const filterDateData = {
                from: moment(startDate).utc(),
                to: moment(endDate).utc(),
            };
            emspFaultySessionReport(filterDateData);
        }
    }, [startDate, endDate, searchText, advanceFilterData]);

    const searchHandler = (event) => {
        const value = event.target.value;
        setSearchText(value);
    };

    const handleSearch = () => {
        emspFaultySessionReport({});
    };

    const downloademspFaultySessionReport = useCallback(() => {
        if (!_.isEmpty(advanceFilterData)) {
            const data = {
                ...advanceFilterData,
                excel: true,
                from: moment(startDate).utc(),
                to: moment(endDate).utc(),
            };
            dispatch({
                type: DOWNLOAD_EMSP_FAULTY_SESSIONS.REQUEST,
                payload: data,
                cb: (res) => {
                    if (res) {
                        if (_.get(res, 'status') === 200) {
                            fileDownload(res.data, `${'EMSP Faulty Session Report'}.xlsx`);
                            toast.success("Report Downloaded")
                        }
                    }
                },
            });
        } else if (searchText) {
            const data = {
                excel: true,
                from: moment(startDate).utc(),
                to: moment(endDate).utc(),
                search: searchText,
            };
            dispatch({
                type: DOWNLOAD_EMSP_FAULTY_SESSIONS.REQUEST,
                payload: data,
                cb: (res) => {
                    if (res) {
                        if (_.get(res, 'status') === 200) {
                            fileDownload(res.data, `${'EMSP Faulty Session Report'}.xlsx`);
                            toast.success("Report Downloaded")
                        }
                    }
                },
            });
        } else {
            const data = {
                excel: true,
                from: moment(startDate).utc(),
                to: moment(endDate).utc(),
            };
            dispatch({
                type: DOWNLOAD_EMSP_FAULTY_SESSIONS.REQUEST,
                payload: data,
                cb: (res) => {
                    if (res) {
                        if (_.get(res, 'status') === 200) {
                            fileDownload(res.data, `${'EMSP Faulty Session Report'}.xlsx`);
                            toast.success("Report Downloaded")
                        }
                    }
                },
            });
        }


    }, [startDate, endDate, advanceFilterData, searchText]);

    const downloadFile = () => {
        downloademspFaultySessionReport();
    };

    const onCloseAdvanceFilterPopup = () => setShowAdvanceFilterPopup(false);

    const handleAdvanceFilterData = (data) => setAdvanceFilterData(data);
    const search = (
        <SearchBox
            preIcon={<BsSearch />}
            value={searchText}
            onChange={searchHandler}
            onKeyPress={(e) => {
                if (e.key === 'Enter') {
                    handleSearch();
                }
            }}
        />
    );

    const initialValues = !_.isEmpty(advanceFilterData) ? { ...advanceFilterData } : { faultyReason: '', partyId: '', payment_status: '' };


    const handlePageClick = useCallback(
        (page) => {
            const data = {
                page: page.selected + 1,
                limit,
            };

            if (searchText) data.search = searchText;

            emspFaultySessionReport(data);
        },
        [searchText, limit, startDate, endDate]
    );

    useEffect(() => {
        emspFaultySessionReport({ page: 1, limit });
    }, [startDate, endDate, searchText]);


    return (
        <>
            <LayoutContainer>
                <AdminHeader title={t('header.emspFaultySessionReport')} />
                <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
                    <div className="page-content-wrapper scrollable">
                        <div className="data-report--main">
                            <Card>
                                <div className="data-report__inner">
                                    <div className="data-report__box">
                                        <Row className="data-report__row">
                                            <Col xl="3" md="2" className="data-report-search-box">
                                                {search}
                                            </Col>
                                            <Col xl={'auto'} md={'auto'}>
                                                <div className="data-report-date_picker">
                                                    <DateTimePicker
                                                        onChangeOfStartDate={(item) => setStartDate(item)}
                                                        onChangeOfEndDate={(item) => setEndDate(item)}
                                                        initialValueOfStartDate={moment(new Date()).startOf('day')}
                                                        initialValueOfEndDate={moment(new Date()).endOf('day')}
                                                    />
                                                </div>
                                            </Col>
                                            <Col xl={'auto'} md={'auto'}>
                                                <div className="report-search-box" onClick={dateFilter}>
                                                    <Button className="report-search-button">{t('button.search')}</Button>
                                                </div>
                                            </Col>
                                            <Col xl={'auto'} md={'auto'}>
                                                <div className="report-search-excel-block">
                                                    <div className="advance-filter-btn" onClick={() => setShowAdvanceFilterPopup(true)}>
                                                        <Button className="report-search-button">
                                                            <FaFilter className="hide-lap" />
                                                            <span>{t('button.advancedFilter')}</span>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xl={'auto'} md={'auto'} className="excel-icon--block">
                                                {isLoading ? (
                                                    <div className="loader--block">
                                                        <Spinner as="span" animation="border" size="sm" role="status" />
                                                    </div>
                                                ) : (
                                                    <div className="report-excel-icon" onClick={downloadFile}>
                                                        <BsDownload title="Download" size={28} color={'#3c7cdd'} />
                                                    </div>
                                                )}
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="data-report__table">
                                        <div className="table-responsive">
                                            <table className="record-list-table" id="table-to-xls">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.srNo')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.external_evse_id')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.bookingId')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.idTag')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.partyId')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.partnerName')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.unitConsumed')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.scheduledDate')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.startTime')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.stopTime')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.startSoc')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.stopSoc')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.vehicleId')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.batteryCapacity')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.paymentStatus')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.faultyReason')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.cdrId')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.userName')}</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className="sorting">
                                                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('dataReport.phone')}</span>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoader ? (
                                                        <tr>
                                                            <td colSpan={16} className="border-0">
                                                                <div className="loader--block">
                                                                    <Skeleton height={15} width={100} />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : _.isEmpty(emspFaultySessionReportList) ? (
                                                        <tr>
                                                            <td colSpan={'auto'} className="border-0">
                                                                <div className="empty-data-block">{t('emspFaultySessionReport.noData')}</div>
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        !(isLoader || _.isUndefined(isLoader)) &&
                                                        _.map(emspFaultySessionReportList, (item, index) => {
                                                            const serial_num = (page - 1) * limit + index + 1;
                                                            return (
                                                                <tr key={`charging-session-report-${item._id || serial_num}`}>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : serial_num}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'charger.external_evse_id', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, '_id', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'idTag', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'ocpiCredential.roles[0].party_id', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'ocpiCredential.partner_name', '-')}</td>
                                                                    <td>
                                                                        {isLoader ? (
                                                                            <Skeleton height={15} width={100} />
                                                                        ) : (
                                                                            _.get(item, 'meterstop', 0) - _.get(item, 'meterstart', 0)
                                                                        )}
                                                                    </td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : moment(item.schedule_datetime).format('DD-MM-YYYY hh:mm:ss')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : moment(item.booking_start).format('DD-MM-YYYY HH:mm:ss')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : moment(item.booking_stop).format('DD-MM-YYYY HH:mm:ss')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'StartSoC', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'StopSoC', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'vehicle._id', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'vehicle.max_charging_capacity', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'payment_status', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'faulty_booking_reason', []).join(', ') || '-'}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, '_id', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'customer_user_booked.name', '-')}</td>
                                                                    <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'customer_user_booked.phone', '-')}</td>
                                                                </tr>

                                                            );
                                                        })
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                            {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(emspFaultySessionReportList) && (
                                <ReactPagination
                                    currentPage={page}
                                    limit={limit}
                                    total={totalResults}
                                    handlePageClick={(pageVal) => handlePageClick(pageVal)}
                                    totalPages={totalPages}
                                    marginPagesDisplayed={1}
                                />
                                // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                            )}
                        </div>
                    </div>
                </SkeletonTheme>
                {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
            </LayoutContainer>

            {/* App User Details Advance Filter Functionality */}

            {showAdvanceFilterPopup && (
                <OffCanvas show={showAdvanceFilterPopup} onClose={onCloseAdvanceFilterPopup}>
                    <Formik
                        enableReinitialize={!_.isEmpty(advanceFilterData)}
                        initialValues={initialValues}
                        onSubmit={(values, { setSubmitting }) => {
                            !values.fleet_member && delete values['fleet_member'];
                            !values.charging_station && delete values['charging_station'];
                            !values.charging_type && delete values['charging_type'];
                            !values.faultyReason && delete values['faultyReason'];
                            !values.partyId && delete values['partyId'];
                            !values.payment_status && delete values['payment_status'];
                            emspFaultySessionReport(values);
                            handleAdvanceFilterData(values);
                            setSubmitting(false);
                            onCloseAdvanceFilterPopup();
                        }}
                    >
                        {({ values, handleSubmit, setFieldValue, resetForm }) => (
                            <Form onSubmit={handleSubmit}>
                                <div className="mb-5">
                                    <Select
                                        label={t('emspFaultySessionReport.faultyReason')}
                                        options={allFaultyBookingReasonList.map((reason) => ({
                                            label: reason,
                                            value: reason,
                                        }))}
                                        placeholder={t('emspFaultySessionReport.faultyReason')}
                                        name="faultyReason"
                                        value={values.faultyReason}
                                        onMenuScrollDown={true}
                                        onChange={(val) => {
                                            setFieldValue('faultyReason', val);
                                        }}
                                    />

                                    <Select
                                        label={t('emspFaultySessionReport.party')}
                                        options={allPartyIdList.map((partyId) => ({
                                            label: partyId,
                                            value: partyId,
                                        }))}
                                        placeholder={t('emspFaultySessionReport.party')}
                                        name="partyId"
                                        value={values.partyId}
                                        onMenuScrollDown={true}
                                        onChange={(val) => {
                                            setFieldValue('partyId', val);
                                        }}
                                    />

                                    <Select
                                        label={t('dataReport.paymentStatus')}
                                        options={[
                                            { label: 'Done', value: 'done' },
                                            { label: 'Pending', value: 'pending' },
                                            { label: 'Action Required', value: 'action_required' },
                                        ]}
                                        placeholder={t('dataReport.paymentStatus')}
                                        name="payment_status"
                                        value={values.payment_status}
                                        onChange={(val) => {
                                            setFieldValue('payment_status', val);
                                        }}
                                    />

                                </div>
                                <div className="canvas-btn__block">
                                    <Button type="submit" className="apply--btn w-100">
                                        {t('button.applyFilters')}
                                    </Button>
                                    <div
                                        className="reset--block"
                                        onClick={() => {
                                            setAdvanceFilterData({});
                                            resetForm();
                                            emspFaultySessionReport();
                                            onCloseAdvanceFilterPopup();
                                        }}
                                    >
                                        <MdClear size={24} className="reset--icon" />
                                        {t('button.clear')}
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </OffCanvas>
            )}
        </>
    );
};

export default EMSPFaultySessionReport;
